module.exports = __webpack_public_path__ + "img/university_15.6a87fafc.png";